module.exports = __webpack_public_path__ + "static/media/experience_illustration_solo.2ec27635.png";